import TargetMatcher from "../../../match/TargetMatcher"
import ExperimentActionResolver from "./ExperimentActionResolver"
import { Variation } from "../../../../model/model"
import { ManualOverrideStorage } from "./ManualOverrideStorage"
import ExperimentLocalEvaluateRequest from "../mode/local/ExperimentLocalEvaluateRequest"
import { EvaluatorContext } from "../../../evaluator/Evaluator"

export default class ExperimentOverrideResolver {
  private readonly manualOverrideStorage: ManualOverrideStorage
  private readonly targetMatcher: TargetMatcher
  private readonly actionResolver: ExperimentActionResolver

  constructor(
    manualOverrideStorage: ManualOverrideStorage,
    targetMatcher: TargetMatcher,
    actionResolver: ExperimentActionResolver
  ) {
    this.manualOverrideStorage = manualOverrideStorage
    this.targetMatcher = targetMatcher
    this.actionResolver = actionResolver
  }

  resolveOrNull(request: ExperimentLocalEvaluateRequest, context: EvaluatorContext): Variation | undefined {
    return (
      this.resolveManualOverride(request) ??
      this._resolveUserOverride(request) ??
      this._resolveSegmentOverride(request, context)
    )
  }

  private resolveManualOverride(request: ExperimentLocalEvaluateRequest): Variation | undefined {
    return this.manualOverrideStorage.getVariation(request.experiment, request.user)
  }

  _resolveUserOverride(request: ExperimentLocalEvaluateRequest): Variation | undefined {
    const experiment = request.experiment
    const identifier = request.user.identifiers[experiment.identifierType]
    if (!identifier) {
      return undefined
    }

    const overriddenVariationId = experiment.userOverrides.get(identifier)
    if (!overriddenVariationId) {
      return undefined
    }

    return experiment._getVariationByIdOrNull(overriddenVariationId)
  }

  _resolveSegmentOverride(request: ExperimentLocalEvaluateRequest, context: EvaluatorContext): Variation | undefined {
    const overriddenRule = request.experiment.segmentOverrides.find((it) =>
      this.targetMatcher.matches(request, context, it.target)
    )
    if (!overriddenRule) {
      return undefined
    }

    return this.actionResolver.resolveOrNull(request, context, overriddenRule.action)
  }
}
